import type { FamilyGroup } from '@/api/types'

/**
 * 家庭组 Mock 数据 (IAM-002)
 * 新增字段: phone, members, cardCount, totalSpentMinor, totalConsumption, remainingConsumption, lastSessionAt
 * 关联推导: 从 leads.ts 的 familyGroupId + entitlements 的 accountId + attendances 的 accountId
 */

export const mockFamilyGroups: FamilyGroup[] = [
  {
    id: 'fg-001',
    name: '赵小明',
    householderCustomerId: 'cu-001',
    householderName: '赵小明',
    primaryCampusId: 'c-001',
    memberCount: 1,
    phone: '13900000001',
    members: '赵小明',
    cardCount: 2,
    totalSpentMinor: 4065000,
    totalConsumption: 5,
    remainingConsumption: 10,
    lastSessionAt: '2025-10-18T09:05:00+08:00',
    address: '北京市朝阳区建国路88号',
    consultantId: 'u-consultant-001',
    createdAt: '2025-01-15T10:00:00+08:00',
  },
  {
    id: 'fg-002',
    name: '蒋红',
    householderCustomerId: 'cu-002',
    householderName: '蒋红',
    primaryCampusId: 'c-001',
    memberCount: 2,
    phone: '13900000012',
    members: '蒋红, 黄磊',
    cardCount: 3,
    totalSpentMinor: 5340000,
    totalConsumption: 6,
    remainingConsumption: 11,
    lastSessionAt: '2025-10-13T14:00:00+08:00',
    address: '北京市海淀区中关村大街1号',
    consultantId: 'u-consultant-001',
    createdAt: '2025-02-20T14:00:00+08:00',
  },
  {
    id: 'fg-003',
    name: '李东',
    householderCustomerId: 'cu-003',
    householderName: '李东',
    primaryCampusId: 'c-002',
    memberCount: 1,
    phone: '13900000020',
    members: '李东',
    cardCount: 2,
    totalSpentMinor: 2280000,
    totalConsumption: 7,
    remainingConsumption: 8,
    lastSessionAt: '2025-10-15T16:10:00+08:00',
    address: '上海市浦东新区世纪大道100号',
    consultantId: 'u-consultant-001',
    createdAt: '2025-03-10T09:30:00+08:00',
  },
  {
    id: 'fg-004',
    name: '张玲',
    householderCustomerId: 'cu-004',
    householderName: '张玲',
    primaryCampusId: 'c-002',
    memberCount: 5,
    phone: '13900000021',
    members: '张玲',
    cardCount: 1,
    totalSpentMinor: 30000,
    totalConsumption: 0,
    remainingConsumption: 0,
    lastSessionAt: '2025-10-15T15:58:00+08:00',
    address: '北京市西城区西直门外大街18号',
    consultantId: 'u-principal-001',
    createdAt: '2025-04-05T11:00:00+08:00',
  },
  {
    id: 'fg-005',
    name: '刘洋',
    householderCustomerId: 'cu-005',
    householderName: '刘洋',
    primaryCampusId: 'c-003',
    memberCount: 3,
    phone: '13900000022',
    members: '刘洋',
    cardCount: 1,
    totalSpentMinor: 1200000,
    totalConsumption: 5,
    remainingConsumption: 0,
    lastSessionAt: '2025-10-15T16:10:00+08:00',
    address: '广州市天河区体育西路191号',
    consultantId: 'u-principal-001',
    createdAt: '2025-05-18T16:00:00+08:00',
  },
  {
    id: 'fg-006',
    name: '陈静',
    householderCustomerId: 'cu-006',
    householderName: '陈静',
    primaryCampusId: 'c-003',
    memberCount: 2,
    phone: '13900000023',
    members: '陈静',
    cardCount: 0,
    totalSpentMinor: 600000,
    totalConsumption: 10,
    remainingConsumption: 0,
    lastSessionAt: null,
    address: '深圳市南山区科技园路1号',
    consultantId: 'u-consultant-001',
    createdAt: '2025-06-22T08:30:00+08:00',
  },
  {
    id: 'fg-007',
    name: '杨光',
    householderCustomerId: 'cu-007',
    householderName: '杨光',
    primaryCampusId: 'c-001',
    memberCount: 6,
    phone: '13900000024',
    members: '杨光',
    cardCount: 1,
    totalSpentMinor: 0,
    totalConsumption: 0,
    remainingConsumption: 999,
    lastSessionAt: null,
    address: '北京市东城区东直门外大街42号',
    consultantId: 'u-consultant-001',
    createdAt: '2025-07-14T13:00:00+08:00',
  },
]
